import img1 from "../../Images/1.jpg";
import img5 from "../../Images/5.jpg";
import img3 from "../../Images/3.jpg";
import img4 from "../../Images/4.jpg";
import img51 from "../../Images/5.1.jpg";
import img6 from "../../Images/6.png";
import img7 from "../../Images/7.png";
import img8 from "../../Images/8.png";

const Pdata = [
  {
    image: img7,
    alts: "FootbyFoot",
    weblink: "https://foot-by-foot-e-commerce.netlify.app/",
    title: "Foot By Foot",
    button: "https://github.com/devmithlesh/footbyfoot.git",
  },
  {
    image: img6,
    alts: "Food-ordring",
    weblink: "https://food-ordering-hub-mithlesh.netlify.app/",
    title: "Food Ordering View ",
    button: "https://github.com/devmithlesh/food-ordering-website.git",
  },
  {
    image: img51,
    alts: "Vigma to Reactjs",
    weblink: "https://assignment-2-15-9-22.netlify.app/",
    title: "Figma to React Project",
    button: "https://github.com/devmithlesh/assignment-2--15-9-22.git",
  },
  {
    image: img8,
    alts: "Rental-house",
    weblink: "https://house-rental-website-by-mithlesh.netlify.app/",
    title: "Rentail website",
    button:
      "https://github.com/devmithlesh/house-rental-wesite-by-mithlesh.git",
  },
  {
    image: img5,
    alts: "Microsoft",
    weblink: "https://clone-microsoft-web.netlify.app/",
    title: "Clone of Microsoft Desigen",
    button: "https://github.com/devmithlesh/microsoft-website-by-mithlesh.git",
  },
  {
    image: img3,
    alts: "Discord",
    weblink: "https://frosty-rosalind-c7620e.netlify.app/",
    title: "Clone of Discord Desigen",
    button:
      "https://github.com/devmithlesh/Discord-web-in-react-js-by-mithlesh.git",
  },
  {
    image: img1,
    alts: "Project",
    weblink: "https://clone-dribble.netlify.app/",
    title: "Clone of Tailblocks Desigen",
    button: "https://github.com/devmithlesh/dribbble-pro.git",
  },

  {
    image: img4,
    alts: "Linkedin",
    weblink: "https://linkedin-by-mithlesh.netlify.app/",
    title: "Clone of Linkedin Desigen",
    button: "https://github.com/devmithlesh/linkedin-by-mithlesh.git",
  },
];

export default Pdata;
